import { useState } from 'react'

/** Keep the last anchor so the popover can exit in place after it is cleared. */
export function useLastPopoverAnchor(anchorEl) {
  const [last, setLast] = useState(null)
  if (anchorEl && anchorEl !== last) setLast(anchorEl)
  return anchorEl ?? last
}
